import { styled } from "@mui/material/styles";
import { Typography, Select, MenuItem } from "@mui/material";

export const StyledLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ theme, color }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "1rem",
  color: color || theme.palette.text.primary,
  fontWeight: "600",
  marginBottom: 8,
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

export const StyledPlaceholder = styled("em", {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color }) => ({
  fontStyle: "'Quicksand', sans-serif",
  fontSize: "14px",
  color: color || "rgba(73,42,24, 0.2)",
}));

export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => !["$color", "$width"].includes(prop),
})(({ theme, $color, $width }) => ({
  width: $width || "100%",
  height: "55px",
  borderRadius: theme.spacing(2),
  backgroundColor: "transparent",
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  fontWeight: "400",
  color: $color || theme.palette.text.primary,
  padding: "0 !important",
  boxShadow:
    "-4px -4px 17.8px 0px rgba(173, 183, 194, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
  "& .MuiFormControl-root": {
    marginTop: "auto",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(73,42,24, 0.2)",
  },
  "& input::placeholder": {
    color: $color || theme.palette.text.primary,
    opacity: 1,
    fontFamily: "'Quicksand', sans-serif",
  },
  "& .MuiSvgIcon-root": {
    fill: "black !important",
  },
  "& input.Mui-disabled": {
    color: theme.palette.text.primary,
    WebkitTextFillColor: theme.palette.text.primary,
  },
}));

export const StyledMenuItem = styled(MenuItem)({
  textTransform: "capitalize",
});
